import { userService } from '../_services';
import { router } from '@/_helpers/router';

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: {}, user: null };

export const authentication = {
  namespaced: true,
  state: initialState,
  actions: {
    clientLogin({ dispatch, commit }, { username, password }) {
      commit('loginRequest', {});
      userService.clientLogin(username, password).then(
        user => {
          if (user && user.error) {
            dispatch('alert/error', user.error, { root: true });
            return commit('loginFailure');
          }
          commit('loginSuccess', user);
          dispatch('app/runApp', {}, { root: true });
          router.push('/');
        },
        error => {
          commit('loginFailure', error);
        }
      );
    },
    neoLogin({ dispatch, commit }, id_token) {
      commit('loginRequest', {});
      userService.neoLogin({ id_token: id_token }).then(
        user => {
          if (!user) {
            commit('loginFailure');
            return
          };
          commit('loginSuccess', user);
          dispatch('app/runApp', {}, { root: true });
          dispatch('refs/getAll', {}, { root: true });
          router.push('/admin');
        },
        error => {
          commit('loginFailure', error);
          dispatch('alert/error', error, { root: true });
        }
      );
    },
    logout({ commit }) {
      userService.logout();
      commit('logout');
      router.push('/login');
    },
  },
  mutations: {
    loginRequest(state) {
      state.status = { loggingIn: true };
    },
    updateUser(state, user) {
      state.user = user;
      localStorage.setItem('user', JSON.stringify(user));
    },
    loginSuccess(state, user) {
      state.status = { loggedIn: true };
      state.user = user;
    },
    loginFailure(state) {
      state.status = {};
      state.user = null;
    },
    logout(state) {
      state.status = {};
      state.user = null;
    },
  },
};
